import { render, staticRenderFns } from "./S8.vue?vue&type=template&id=33f78a3e&scoped=true&"
import script from "./S8.vue?vue&type=script&lang=js&"
export * from "./S8.vue?vue&type=script&lang=js&"
import style0 from "./S8.vue?vue&type=style&index=0&id=33f78a3e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f78a3e",
  null
  
)

export default component.exports